import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [redirectToDashboard, setRedirectToDashboard] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const loginResponse = await axios.post(
        "https://portal.automonster.pl/api/token",
        { username, password }
      );

      const { token, user } = loginResponse.data;

      localStorage.setItem("auth_token", token);
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("username", user.name); // lub user.username, jeśli chcesz

      onLogin(user.name); // aktualizuje stan w App.jsx
      window.location.href = "/";
      setRedirectToDashboard(true); // wyzwala przekierowanie
    } catch (err) {
      console.error("Login error:", err);
      setError("Błędna nazwa użytkownika lub hasło.");
    }
  };

  // Po zalogowaniu – przekieruj do dashboard
  if (redirectToDashboard) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: "100vh" }}>
      <div className="w-100" style={{ maxWidth: "400px" }}>
        <h2 className="text-center mb-4">Zaloguj się</h2>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">Nazwa użytkownika</label>
            <input
              id="username"
              type="text"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">Hasło</label>
            <input
              id="password"
              type="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button type="submit" className="btn btn-primary w-100">
            Zaloguj
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
